import React, { useState } from "react"
import styled from "styled-components"
import { Button, FullScreenLoadingCover, Modal } from "@prosolve/common-components-ui"
import ConfirmModal from "../../sharedComponents/ConfirmModal"
import FileUpload from "../../sharedComponents/FileUpload"
import useDataUserAccount from "../../dataHooks/useDataUserAccount"

const Container = styled.div`
  font-size: 14px;
`

const RemoveButton = styled(Button)`
  background: red;
`

export default ({
  userAccount,
  onClose
}) => {
  const { headshot } = userAccount || {}
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)

  const { isLoading, postUserHeadshot } = useDataUserAccount()

  const handleFilesChanged = async (files) => {
    const file = files?.[0]
    if (!file) return
    await postUserHeadshot(file)
    await onClose({ update: true })
  }

  const handleRemove = async () => {
    setIsDeleteConfirm(true)
  }

  const handleRemoveConfirm = async () => {
    await postUserHeadshot()
    setIsDeleteConfirm(false)
    await onClose({ update: true })
  }

  return (
    <Container>
      <Modal 
        title='Upload Profile Image'
        onClose={onClose} 
        isAutoWidth={true}
        isAutoHeight={true}
        footer={headshot && (
          <div style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            columnGap: '10px',
            padding: '10px'
          }}>
            <RemoveButton onClick={handleRemove} $colored={true}>
              {'Remove Existing Image'}
            </RemoveButton>
          </div>
        )}
      >
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          padding: '20px',
          minWidth: '350px'
        }}>
          <FileUpload 
            onFilesChanged={handleFilesChanged} 
            isSingleFile={true}
            allowedFileTypes={[
              'image/jpeg',
              'image/png'
            ]}
          />
          <div>File types accepted: .jpg, .jpeg, .png</div>
        </div>
      </Modal>
      {isLoading &&
        <FullScreenLoadingCover />
      }
      {isDeleteConfirm &&
        <ConfirmModal
          message='Are you sure you want to remove the existing profile image?'
          onClose={() => setIsDeleteConfirm(false)}
          onConfirm={handleRemoveConfirm}
        />
      }
    </Container>
  )
}
